import SignersBlock from 'page-components/integrations/docusign/SignersBlock';
import AppContentLayout from 'shared-components/AppContentLayout';

const noop = () => {
  /* no-op */
};

const CypressTestsPage = () => {
  return (
    <>
      <AppContentLayout title="CypressTestsPage">
        <div className="relative" data-cy="sypress-tests-page">
          <SignersBlock
            signerBlocks={[] as any}
            setSignerBlocks={noop}
            droppedItems={[] as any}
            setDroppedItems={noop}
            isSigningOrderActive={false}
            setIsSigningOrderActive={noop}
          />
        </div>
      </AppContentLayout>
    </>
  );
};

export default CypressTestsPage;
